import styled from "styled-components";

export const Text = styled.p`
  font-family: 'Lato', sans-serif;
`
